import React from 'react'

const OrderSubcriptionLayout = () => {
  return (
    <div>
      <h1>OrderSubcriptionLayout</h1>
    </div>
  )
}

export default OrderSubcriptionLayout
